/**
 * SwiperFullpage 0.1.0
 */


(function () {
    'use strict';

    //继承方法

    var inherit = (subClass, superClass) => {
        function F() {};
        F.prototype = superClass.prototype;  
        subClass.prototype = new F();  
        subClass.prototype.constructor = subClass.constructor;  
    }

    var InjectCSS = (cssText) => {
        var style = document.createElement('style'),  //创建一个style元素
            head = document.head || document.getElementsByTagName('head')[0]; //获取head元素
        style.type = 'text/css'; //这里必须显示设置style元素的type属性为text/css，否则在ie中不起作用
        if(style.styleSheet){ //IE
            var func = function(){
                try{ //防止IE中stylesheet数量超过限制而发生错误
                    style.styleSheet.cssText = cssText;
                }catch(e){

                }
            }
            //如果当前styleSheet还不能用，则放到异步中则行
            if(style.styleSheet.disabled){
                setTimeout(func,10);
            }else{
                func();
            }
        }else{ //w3c
            //w3c浏览器中只要创建文本节点插入到style元素中就行了
            var textNode = document.createTextNode(cssText);
            style.appendChild(textNode);
        }
        head.appendChild(style); //把创建的style元素插入到head中    
    }


    var SwiperFullpage= function(container, params){
        var sf = this;

        /**
         * 注入样式
         */
        sf.__injectStyle = (data) => {
            let style = '';
            let mobileStyle = '@media (max-width: 800px) {';

            data.map((obj,k)=>{
                if (obj.imgs) {
                    style += `.bg-${k+1} {background-image: url(${obj.imgs[0]});}`;
                    mobileStyle += `#swiper-section-${k+1} {background-image: url(${obj.imgs[0]});}`;
                }
                else if (obj.video) {
                    style += `.bg-${k+1} {background-color: #fff;}`;
                    mobileStyle += `#swiper-section-${k+1} {background-image: url(${obj.video.img});}`;
                }
            });

            style += `${mobileStyle} }`;
            
            InjectCSS(style);
        };

        /**
         * 渲染视频
         */
        sf.__renderVideos = (data) => {

            data.map((obj,k)=>{
                if (obj.video) {
                    sf.wrapper.append(`<div class="fullscreen-bg">
                                <video loop muted id="videoplayer-${k+1}" class="fullscreen-bg__video">
                                    <source src="${obj.video.src}" type="video/mp4">
                                    <img src="${obj.video.img}" title="Your browser does not support the <video> tag">
                                </video>
                            </div>`);
                    obj.video['father'] =   sf.$(`#videoplayer-${k+1}`).parent();
                    obj.video['videoplayer'] = document.getElementById(`videoplayer-${k+1}`);
                    obj.video['videoplayer'].pause();
                }
            });

        };

        /**
         * 渲染 sections
         */
        sf.__renderSections = (data) => {

            data.map((obj,k)=>{
                let htm = `<div id="swiper-section-${k+1}" class="swiper-section swiper-slide">`;
                if (obj.imgs) {
                    obj.imgs.map((src,i)=>{
                        if (i==0) {
                            htm += `<img class="hiddenimage cur" src="${src}" />`;
                        } else {
                            htm += `<img class="hiddenimage" src="${src}" />`;
                        }
                    });
                }
                htm += `<div class="info">
                            <p><strong>${obj.title}</strong></p>
                            <a href="${obj.link}" class="btn">${obj.linkName}</a>
                        </div>
                    </div>`;
                sf.wrapper.append(htm); 
                obj['section'] = sf.$(`#swiper-section-${k+1}`);
            });

        };

        /**
         * 初始默认显示
         */
        sf.__initDeffWrapper = (fistData) => {
            this.wrapper.addClass('bg-1');
            if (fistData.video) {
                fistData.video.father.toggleClass('on');
                fistData.video.videoplayer.play();
            }
        };

        /**
         * 绑定事件
         */
        sf.__bindEvent = () => {

            this.params.data.map( (obj,k) => {

                obj.section.on('mouseover', ()=>{
                    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    if (w <= 800) return;
                    if (k != 0) {
                        sf.wrapper.addClass(`bg-${k+1}`);
                    }
                    if (obj.imgs) {
                        sf.$('.fullscreen-bg').removeClass('on');
                        obj.timer = setInterval(()=>{
                            let curImg = obj.section.find('img.cur'),
                                nextImg = curImg.next('img').length ? curImg.next('img') : obj.section.find('img').eq(0);
                            curImg.removeClass('cur');
                            nextImg.addClass('cur');
                            sf.wrapper.css('background-image', 'url(' + nextImg.attr('src') + ')');      
                        },1500);
                    } 
                    else if (obj.video) {
                        obj.video.father.addClass('on');
                        obj.video.videoplayer.play();
                    }
                });

                obj.section.on('mouseout', ()=>{
                    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    if (w <= 800) return;
                    if (obj.timer) {clearInterval(obj.timer)};
                    if (k != 0) {
                        sf.wrapper.removeClass(`bg-${k+1}`);
                    }
                    sf.wrapper.css('background-image', '');

                    if (obj.video && k!=0) {
                        obj.video.father.removeClass('on');
                    }

                    if (sf.params.data[0].video) {
                        sf.params.data[0].video.father.addClass('on');
                    }

                });

            });

        };

        /**
         * Swiper onInit
         */
        params.onInit = function(s) {

            // 注入样式
            s.__injectStyle(s.params.data);

            // 渲染视频
            s.__renderVideos(s.params.data);
            // console.log(s.params.data)

            // 渲染 sections
            s.__renderSections(s.params.data);

            // 初始默认显示
            s.__initDeffWrapper(s.params.data[0]);

            // 绑定事件
            s.__bindEvent();

            s.update();
        }

        Swiper.call(this,container, params);

        return sf;
    };

    inherit(SwiperFullpage, Swiper);
    // console.log(SwiperFullpage)

    window.SwiperFullpage = SwiperFullpage;

})();

/*===========================
SwiperFullpage AMD Export
===========================*/
if (typeof(module) !== 'undefined')
{
    module.exports = window.SwiperFullpage;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.SwiperFullpage;
    });
}
